import ApiFactory from '@/factories/ApiFactory'
import {serialize} from '@/utilities/querySerialize'

export default {
  list (year) {
    return new Promise((resolve, reject) => {
      ApiFactory.get(`v1/holidays?${serialize(year)}`)
        .then(
          (success) => resolve(success.data),
          (error) => reject(error)
        ).catch(e => reject(e))
    })
  },
  downloadExcelExample: () => {
    return new Promise((resolve, reject) => {
      ApiFactory({
        url: `v1/holidays/actions/downloadExcelExample`,
        method: 'GET',
        responseType: 'blob'
      }).then(
        (success) => {
          const url = window.URL.createObjectURL(new Blob([success.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'holidays_import_example.xlsx');
          document.body.appendChild(link);
          link.click();
          resolve()
        },
        (error) => reject(error)
      );
    });
  },
  holidays (params) {
    return new Promise((resolve, reject) => {
      ApiFactory.get(`v1/daysOff?${serialize(params)}`)
        .then(
          (success) => resolve(success.data),
          (error) => reject(error)
        ).catch(e => reject(e))
    })
  },
  getMonthData (params) {
    return new Promise((resolve, reject) => {
      ApiFactory.get(`v1/getMonthData?${serialize(params)}`)
        .then(
          (success) => resolve(success.data),
          (error) => reject(error)
        ).catch(e => reject(e))
    })
  },
  create (payload) {
    return new Promise((resolve, reject) => {
      ApiFactory.post('v1/holidays', payload).then(
        (success) => resolve(success.data),
        (error) => reject(error)
      )
    })
  },
}
